import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action = {}
) {
  switch (action.type) {
    case homeConstants.GET_DEVICE_DETAILS_REQUEST:
      return {
        ...state,
        data: null,
        isProgress: true,
      };
    case homeConstants.GET_DEVICE_DETAILS_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.GET_DEVICE_DETAILS_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
